/**
 * Static database for the map
 * @property {number} floorIndex - Order of the floor
 * @property {array} vertices - Vertices on map to traverse
 * @property {array} connections - Path (connection between vertices) that could be traversed through map
 */
import { facility, touchDevices } from 'config/constants';
import connections from './connections.json';
import vertices from './vertices.json';
import titleRotates from './titleRotates.json';

export const availableTouchDevices = [81, 147, 99, 116, 107, 158, 124, 127]

export default {
  floorIndex: 2,
  vertices,
  connections,
  titleRotates,
  deviceLocations: availableTouchDevices,
  [facility.elevators]: [54, 60, 70, 152],
  [facility.escalators]: [55, 58, 61, 62, 66, 67, 71, 72],
  [facility.toilets]: [59, 64, 73, 151],
  [facility.atms]: [],
  [facility.restArea]: [56, 63, 68],
  [facility.chargeArea]: [69],
  [facility.lockers]: [],
  [facility.babyCare]: [157],
  [facility.smokeArea]: [65],
  [facility.infoStall]: [],
  [facility.taxi]: []
};

export { vertices, titleRotates };
